// extracted by mini-css-extract-plugin
export default {"reveal":"reveal_reveal__jXwSq","visible":"reveal_visible__Wp2-s","fade-up":"reveal_fade-up__PR50c","fade-right":"reveal_fade-right__x7GfH","fade-left":"reveal_fade-left__tXOHg"};